import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Language, useI18n } from '@/contexts';
import classnames from 'classnames';
import { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { Icon } from '../Icon';
import styles from './index.module.less';
const langMap = {
    [Language.En]: 'En',
    [Language.Zh]: '中文',
    [Language.Jp]: '日本語',
};
const langList = Object.keys(Language)
    .filter((l) => isNaN(+l))
    .map((l) => Language[l]);
export const LanguageSwitcher = ({ className, ...rest }) => {
    const ref = useRef(null);
    const { language, setLanguage } = useI18n();
    const [menuVisible, setMenuVisible] = useState(false);
    useClickAway(ref, () => {
        setMenuVisible(false);
    });
    return (_jsxs("div", { className: classnames(className, styles.langSwitch), ...rest, ref: ref, "aria-expanded": menuVisible, children: [_jsxs("div", { className: styles.labels, role: "button", onClick: () => setMenuVisible(true), children: [_jsx(Icon, { type: "earth", className: styles.icon }), langMap[language], _jsx(Icon, { type: "arrowDown", className: styles.icon })] }), menuVisible && (_jsx("ul", { className: styles.langs, role: "menu", children: langList.map((l) => (_jsx("li", { className: styles.lang, role: "menuitem", onClick: () => {
                        setLanguage(l);
                        setMenuVisible(false);
                    }, children: langMap[l] }, l))) }))] }));
};
